<template>
  <div>
    <!-- Joined Campaign Contents -->
    <div
      class="row flex-row flex-nowrap justify-content-center"
      style="overflow-x: hidden"
    >
      <!-- Left Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->

      <!-- Joined Campaign Contents Card -->
      <div class="card shadow customs-card mx-2">
        <!-- Joined Campaign Label -->
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">
            参加済キャンペーン
          </p>
        </div>
        <div class="card-body p-4 d-flex align-items-center justify-content-center">
          <!-- Campaign Image -->
          <div class="row">
            <div class="col-10 p-0 mx-auto">
              <img
                :src="campaign.image"
                :alt="campaign.id"
                class="img-fluid mx-auto d-block"
              />
            </div>
          </div>
        </div>

        <div class="card-footer border-0 mb-4">
          <!-- Campaign Name -->
          <p class="m-0 mb-1 text-center font-weight-bold text-bold text-color" v-html="campaign.name">
            <!--{{ campaign.name }}-->
          </p>

          <div class="text-justify text text-color text-center mb-0">
            応募日 : {{ campaign.date }}
          </div>
        </div>

        <!-- Joined Campaign Label  -->
        <a v-if="is_shared"
          @click="updateSharedStatus()"
          class="btn card-footer border-0 background-danger text-center font-weight-bold text-bold text-white"
          style="
            border-bottom-left-radius: 1rem;
            border-bottom-right-radius: 1rem;
          "
          >LINEでシェアしてリトライする<i class="ml-2 ti-angle-right"></i
        ></a>
      </div>

      <!-- Right Side Card 
      <div class="card shadow customs-card mx-2">
        <div class="card-header border-0 py-2 mt-4 background-card">
          <p class="text-center mb-0 font-weight-bold headline text-white">|</p>
        </div>
      </div>-->
    </div>

    <!-- Cautions Label and Cautions Details -->
    <cautions :cautions="cautions"></cautions>
  </div>
</template>

<script>
import { enretryCampaign, retryCampaign, checkShareLine } from "@/api/campaign";
import { getUserId, getUserAgentMobile } from "@/utils/auth";
import {
  getCampaignId,
  getCampaignCautions,
  setState,
  setSharedLine,
  getSharedLine,
  getIsJoinShare,
  setIsJoinShare,
  setIsRetry,
  getIsRetry,
  getTimerId,
  setTimerId,
  getLinkShare,
  setLinkShare,
  setIsShared,
  getIsShared,
  getIsShareable
} from "@/utils/campaign";
import { setErrorMessage } from "@/utils/error";

import Cautions from "@/components/Cautions.vue";

import { sharedCampaign } from "@/api/campaign";

import store from "../store/index";

export default {
  components: {
    Cautions,
  },
  data() {
    return {
      campaign: {
        name: "",
        date: "",
      },
      cautions: "",
      line_share_url: (getUserAgentMobile() == 'true') ? process.env.LINE_SHARE_URL + getLinkShare() : process.env.LINE_SHARE_URL_PC + getLinkShare(),
      is_shared: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    const query = {
      user_id: getUserId(),
      campaign_id: getCampaignId(),
    };
    // get Retry Entry Campaign data from api and set to data
    enretryCampaign(query)
      .then((response) => {
        if (response.status === "success") {
          return next((vm) => {
            // set campaign data (name, description, caution, application_date)
            vm.setData(response);

            // set caution data
            vm.setCampaignCautions(response.caution);
          });
        } else {
          throw new Error(response);
        }
      })
      .catch((error) => {
        console.error(error.message);
        setErrorMessage(error.statusCode);
        next("/error");
      });

    // Get link share line
    checkShareLine({
      campaign_id: getCampaignId(),
      user_agent_mobile: getUserAgentMobile()
    }).then((data) => {
      if (data.result.url) {
        setLinkShare(data.result.url);
        let currentShared = data.result.share;
        setSharedLine(currentShared);
      }
    });
  },
  async created() {
    // Check user shared campaign to redirect to main page
    let isShared = getIsShared()
    if (parseInt(isShared) === 1) {
      // set state to not-play
      setState("not-play");
      setIsShared(0)
      return this.$router.push("/main");
    }

    // Set Share status
    setIsJoinShare(0);
    try {
      if (parseInt(getIsRetry()) === 1) {
        // Update retried
        setIsRetry(0);
        await retryCampaign({ campaign_id: getCampaignId(), is_update: 1 });
      }
      const isRetry = await retryCampaign({ campaign_id: getCampaignId() });
      if (isRetry.status === "success") {
        // check retry status
        if (isRetry.result.retry === 0) {
          setIsJoinShare(1);
          setIsRetry(0);
          this.is_shared = parseInt(getIsShareable());
        } else {
          setState("lose-retried");
        }
      } else {
        throw new Error(isRetry.message);
      }
    } catch (error) {
      console.error(error);
      return this.$router.push("/not-found");
    }
  },
  mounted() {
    let timerId = setInterval(this.shareLine, 5000);
    setTimerId(timerId);
  },
  methods: {
    async shareLine() {
      console.log("timer running ");
      // Store Total Share with Line
      if (parseInt(getIsJoinShare()) === 1) {
        let checkShare = await checkShareLine({
          campaign_id: getCampaignId(),
          user_agent_mobile: getUserAgentMobile()
        });
        if (checkShare.result) {
          let currentShared = checkShare.result.share;
          setSharedLine(currentShared);
          // Check user shared campaign to redirect to main page
          if (parseInt(getIsShared()) === 1) {
            setIsJoinShare(0);
            setIsRetry(1);
            clearInterval(getTimerId());
            // set state to not-play
            setState("not-play");
            setIsShared(0)
            return this.$router.push("/main");
          }
        }
      }
    },
    setData(response) {
      this.campaign.name = response.result.name || "";
      this.campaign.date = response.result.application_date || "";
    },
    setCampaignCautions(cautions) {
      this.cautions = cautions;
    },
    async updateSharedStatus() {
      store.dispatch("setLoading", true);
      await sharedCampaign({campaign_id: getCampaignId(), is_shared: 1})
      setIsShared(1)
      setIsJoinShare(1);
      store.dispatch("setLoading", false);

      window.location.href = this.line_share_url
    }
  },
};
</script>

<style scoped></style>
